export const COMMENT_PAGE_SIZE = 15;

function endpoint(objectKey: string): string {
  return `comments/${encodeURIComponent(objectKey)}/`;
}

function pageUrl(objectKey: string, params: Record<string, number>): string {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    query.set(key, value.toString());
  }
  return `${endpoint(objectKey)}?${query.toString()}`;
}

export function buildInitialCommentUrl(objectKey: string, anchor: number | null): string {
  return anchor === null
    ? pageUrl(objectKey, { limit: COMMENT_PAGE_SIZE })
    : pageUrl(objectKey, { limit: COMMENT_PAGE_SIZE, around: anchor });
}

export function buildOlderCommentUrl(objectKey: string, before: number): string {
  return pageUrl(objectKey, { limit: COMMENT_PAGE_SIZE, before });
}

export function buildNewerCommentUrl(objectKey: string, after: number): string {
  return pageUrl(objectKey, { limit: COMMENT_PAGE_SIZE, after });
}

export function buildCommentSummaryUrl(objectKey: string): string {
  return pageUrl(objectKey, { limit: 0 });
}

export function buildCommentUrl(objectKey: string): string {
  return endpoint(objectKey);
}

export function buildDeleteCommentUrl(objectKey: string, id: number): string {
  return `${endpoint(objectKey)}${id}/`;
}
